import { Outlet, useLocation } from 'react-router'
import { ChatListPane } from './ChatListPane'
import { ChatIcon } from '../components/Icons'
import { useT } from '../lib/i18n'

/**
 * Two-pane shell. Wide screens show the list next to the open thread; narrow screens show one pane
 * at a time (list → thread, with the header's back affordance).
 *
 * The list column is a fixed 384px of *room*, not a strip: it keeps the raised surface tone all the
 * way down so the window reads as one lit interior with a divider in it, instead of a phone-shaped
 * list floating in a black void — which is what 360px on a 1280px display looked like.
 */
export function ChatShell() {
  const t = useT()
  const location = useLocation()
  const hasThread = location.pathname.startsWith('/chat/')

  return (
    <div className="app-shell md:flex-row">
      <aside
        className={`min-h-0 w-full flex-1 md:flex md:w-96 md:flex-none md:flex-col md:border-e md:border-line ${
          hasThread ? 'hidden' : 'flex flex-col'
        }`}
      >
        <ChatListPane />
      </aside>
      <section className={`min-h-0 min-w-0 flex-1 ${hasThread ? 'flex flex-col' : 'hidden md:flex md:flex-col'}`}>
        {hasThread ? (
          <Outlet />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
            <span
              aria-hidden="true"
              className="flex size-14 items-center justify-center rounded-full bg-accent/10 text-accent ring-1 ring-accent/25 ring-inset"
            >
              <ChatIcon size={26} />
            </span>
            <p className="text-body font-semibold text-ink">{t('chat.openAChat')}</p>
            <p className="max-w-[24rem] text-ui text-muted">{t('chat.openAChatHint')}</p>
          </div>
        )}
      </section>
    </div>
  )
}
